<script lang="ts" setup>
import {onMounted, ref} from "vue";
import Loader from "@/components/Loader.vue";
import SignIn from "@/_demo/SignIn.vue";
import LanguageSelection from "@/components/LanguageSelection.vue";

defineOptions({ name: "DemoAdmin" });

const showLoader = ref(true);

onMounted(() => {
  document.title = "Admin/Demo";
	setTimeout(
					() => {
			// Simulate a delay for demonstration purposes
						showLoader.value = false;
		},
		3000 
	);
});

</script>

<template>
  <div>
    <h2>Test Admin Page</h2>
    <p>This is the test view for admin.</p>
  </div>
  <div v-if="showLoader" class="loader-container">
    <loader size="s" text="Loading something ..."/>
  </div>
  <div v-if="!showLoader">
    <language-selection :initialLang="'et'"/>
    <sign-in class="demo-sign-in"/>
  </div>
</template>
<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
  position: relative;
}
</style>
